import React, { Component } from "react";
import ReactTable from "react-table";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { LoginService } from "../../services/login.service";
import * as moment from "moment";
import * as Yup from "yup";
import loadable from '@loadable/component';
import { StudentAssessmentService } from "../../services/studentAssessment.service";
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import { ExcelService } from "../Excel/excel";
import Finxfooter from "../../containers/finxfooter/finxfooter";
import { Global_var } from "../../global/global_var";
import {
  errorNotification,
  error,
  warning,
  warningNotification,
  success,
  successNotification,
} from "../notification/notifications";
const AdminHeader = loadable(() => import("../../components/dashboardheader/adminheader"));


export class AdminCadidate extends Component {
  constructor(props) {
    super(props);
    var todaydate = new Date();
    this.state = {
      today: moment(todaydate).format("YYYY-MM-DD"),
      data: [],
      roleId: 0,
      listOfYear1: [],
      listOfYear2: [],
      listOfMonth: [],
      listOfDay: [],
      loading: true,
      candidateStatus: "",
      studentId: "",
      emailId: "",
      applicationRejectComment: "",
      applicationStageComment: "",
      commentCheck: false,
      stageCommentCheck: false,
      applicationId: "",
      applicationStatus: "",
      partyId: "",
      jobId: "",
      emailCheck: false,
      applicationEmailId: "",
      candidateMobileNo: "",
      candidateEmailId: "",
      candidateEntryDate: "",
      corporateName: "",
      jobRole: "",
      InterviewStageList:"",
      candidateId:"",
      updateStatus:"",
      statusComment:"",
      jobHistory:[],
      tokenClient: {},
      isEdit: false,
      // Stage & Status Modal Job ID
      modalJobId:"",
      today1:"",
      tomonth:"",
      toyear:"",
      fromday:"",
      frommonth:"",
      fromyear:"",
      isButtonDisabled:false,
      isStatusBtnDisabled: false,
      searchType:"Job",
      selectedRecords:[],
      selectAll:false,
    };
    // this.showAll = this.showAll.bind(this);

  }

  addEventToCalander = (data1) => {
    console.log("ddddddddd", this.state.tokenClient);
    console.log("windowgapi",window.gapi);

    this.state.tokenClient.callback = async (resp) => {
      console.log(
        "this.state.tokenClient && this.state.tokenClient.callback " + resp
      );
      if (resp.error !== undefined) {
        console.error("resssssssp", resp);
      }
      try {
        const event = data1;
        const request = window.gapi.client.calendar.events.insert({
          calendarId: "primary",
          resource: event,
        });
        console.log("rrrrr", request);

        request.execute(function (event) {
          console.log("Event created: " + JSON.stringify(event, null, 2));
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (err) {
        console.error(err);
        console.log("eeeerrrrr", err);
        return;
      }
    };
    console.log('getToken',window.gapi.client);
    
    if (window.gapi.client.getToken() === null) {
      // Prompt the user to select a Google Account
      // and ask for consent to share their data
      // when establishing a new session.
      this.state.tokenClient &&
        this.state.tokenClient.requestAccessToken({ prompt: "consent" });

      console.log("aaaaddddddddd", data1);
    } else {
      // Skip display of account chooser
      // and consent dialog for an existing session.
      this.state.tokenClient &&
        this.state.tokenClient.requestAccessToken({ prompt: "" });
      console.log("aabbbbbbbbaaddddddddd", data1);
    }
  };
handleDate=()=>{
  let endDate = new Date();
  let startDate = new Date();
  startDate.setDate(endDate.getDate() - 31);
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };
  let dateFormatter = new Intl.DateTimeFormat('en-IN', options);
  let startDate2 = dateFormatter.format(startDate);
  let endDate2 = dateFormatter.format(endDate);
  this.setState({
    fromDate: startDate2 ? startDate2 : "",
    toDate: endDate2 ? endDate2 : "",
  });
  this.setState({
    fromday:
      parseInt(startDate2.split("/")[0]) < 10 &&
      startDate2.split("/")[0].includes("0")
        ? parseInt(`${startDate2.split("/")[0].replace("0", "")}`)
        : parseInt(`${startDate2.split("/")[0]}`),
    frommonth:
      parseInt(startDate2.split("/")[1]) < 10 &&
      startDate2.split("/")[1].includes("0")
        ? parseInt(`${startDate2.split("/")[1].replace("0", "")}`)
        : parseInt(`${startDate2.split("/")[1]}`),
    fromyear: startDate2.split("/")[2],
    today1:
      parseInt(endDate2.split("/")[0]) < 10 &&
      endDate2.split("/")[0].includes("0")
        ? parseInt(`${endDate2.split("/")[0].replace("0", "")}`)
        : parseInt(`${endDate2.split("/")[0]}`),
    tomonth:
      parseInt(endDate2.split("/")[1]) < 10 &&
      endDate2.split("/")[1].includes("0")
        ? parseInt(`${endDate2.split("/")[1].replace("0", "")}`)
        : parseInt(`${endDate2.split("/")[1]}`),
    toyear: endDate2.split("/")[2],
  });

}
componentWillMount(){
  this.handleDate();
 
}
  componentDidMount() { 
    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
    });
    this.setState({loading:true})
    // StudentAssessmentService.getCandidateJobDetails("candidateID=&fromDate=&toDate=&jobId=0&applicationStatus=", (res) => {
          StudentAssessmentService.getCandidateJobDetails(`candidateID=&fromDate=${this.state.fromDate}&toDate=${this.state.toDate}&jobId=0&productId=&applicationStatus=&reportFlag=JOB`, (res) => {
      
      console.log('candidate res',res);
      
      if (res.status === "success") {
        this.setState({loading:false})
        this.setState({ data: res.responseListObject });
      }
    })
    StudentAssessmentService.getInterviewStage("studentID=0", 
    (res) => {
      if (res.status === "success") {
        this.setState({loading:false})
        this.setState({ InterviewStageList: res.responseListObject });
        let InterviewStageListForCourse=res.responseListObject.filter((item)=>item.stageTypeName === "Screening Call");
        this.setState({
          InterviewStageListForCourse
        })
        console.log("new stage",this.state.InterviewStageList);
      }
    })
    this.initailizedDateDetails();
    this.setState({ loading: false });

    console.log("gapi",window.gapi);

setTimeout(()=>{
   // ! Google Load
      window.gapi.load("client", async () => {
        await window.gapi.client.init({
          apiKey: Global_var.URL_API_KEY,
          discoveryDocs: [Global_var.URL_DISCOVERY_DOC],
        });
        this.setState({ gapiInited: true }, () =>
        console.log("Client Activated")
        );
      });
  
  // !Init Google API
  var tokenClient = window.google.accounts.oauth2.initTokenClient({
    client_id: Global_var.URL_CLIENT_ID,
    scope: Global_var.URL_SCOPES,
    callback: "",
  });
  this.setState({ gisInited: true, tokenClient }, () =>
    console.log("API Activated")
  );
},1000);      
  }

  initailizedDateDetails() {
    var listOfYear = [];
    var listOfMonth = [];
    var listOfDay = [];
    var listOfYear2 = [];
    var year = new Date().getFullYear();

    for (var i = 0; i < 100; i++) {
      var current = year - i;
      listOfYear.push(current);
    }

    for (var i = 0; i < 10; i++) {
      var current = year + i;
      listOfYear2.push(current);
    }

    listOfMonth = [
      { key: 1, value: "Jan" },
      { key: 2, value: "Feb" },
      { key: 3, value: "Mar" },
      { key: 4, value: "Apr" },
      { key: 5, value: "May" },
      { key: 6, value: "Jun" },
      { key: 7, value: "Jul" },
      { key: 8, value: "Aug" },
      { key: 9, value: "Sep" },
      { key: 10, value: "Oct" },
      { key: 11, value: "Nov" },
      { key: 12, value: "Dec" },
    ];

    for (var ld = 1; ld <= 31; ld++) {
      listOfDay.push(ld);
    }
    this.setState({ listOfYear2: listOfYear2 });
    this.setState({ listOfMonth: listOfMonth });
    this.setState({ listOfYear: listOfYear });
    this.setState({ listOfYear1: listOfYear });
    this.setState({ listOfDay: listOfDay });
  }

  exportToCSV = (type) => {
    this.setState({ loading: true });
    if(type==="Job"){
    let modifiedData = [];
    // let data = this.state.selectedRecords;
    let data = this.state.data;
    if(data.length===0){
    var data1 = {
      Candidate: "",
      Corporate:"",
      Mobile_No:"",
      Job: "",
      Location:"",
      Applied_Date: "",
      Question_Passed_Failed: "",
      Application_Status: ""   
     }
    modifiedData.push(data1);
  

}
    data.forEach(element => {      
      var data1 = {
        Candidate: element.candidateID,
        Corporate:element.corporate,
        Mobile_No:element.mobileNo,
        Job: element.job,
        Location:element.locationName,
        Applied_Date: element.appliedDate,
        Question_Passed_Failed: element.result,
        Application_Status: element.applicationStatus
      }
      modifiedData.push(data1);
    });

    ExcelService.ExcelData2(modifiedData, 'Client_Report-');
  }
  if(type==="Course"){
    let modifiedData2 = [];
    // let data = this.state.selectedRecords;
    let data = this.state.data;
    if(data.length===0){
    var data2 = {
      Candidate: "",
      Mobile_No:"",
      Course: "",
      Applied_Date: "",
      Question_Passed_Failed: "",
      Application_Status: ""   
     }
    modifiedData2.push(data2);
}
    data.forEach(element => {      
      var data2 = {
        Candidate: element.candidateID,
        Mobile_No:element.mobileNo,
        Course: element.course,
        Applied_Date: element.appliedDate,
        Question_Passed_Failed: element.result,
        Application_Status: element.applicationStatus
      }
      modifiedData2.push(data2);
    });

    ExcelService.ExcelData3(modifiedData2, 'Client_Report-');



  }
    this.setState({ loading: false });
  };

  showAll=async () =>{
    this.setState({ loading: true });
   await this.setState({
      fromyear: "",
      frommonth: "",
      fromday: "",
      toyear: "",
      tomonth: "",
      today1: "",
      candidateStatus: "",
      jobId:"",
      courseId:"",
      studentId:"",
      searchType:"Job"
    })
  
   await StudentAssessmentService.getCandidateJobDetails("candidateID=&fromDate=&toDate=&jobId=&productId=&applicationStatus=&reportFlag=JOB", (res) => {
      console.log('candidate res',res);
      
      if (res.status === "success") {
        this.setState({loading:false})
        this.setState({ data: res.responseListObject });
      }
    })
    
    await this.handleDate();
    let data = {
      startDate: "",
      endDate: "",
      candidateStatus: "",
      startDate:this.state.fromDate,
      endDate:this.state.toDate
    };
    await this.generateData(data,"JOB");
    this.setState({ loading: false });
  }

  filterCaseInsensitive = ({ id, value }, row) => {
    return row[id] !== undefined ? String(row[id].toLowerCase()).includes(value.toLowerCase()) : true
  }

  generateData(data,type) {

    this.setState({ loading: true });
    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
      let productId = data.productId ?data.productId:""
      let jobId = data.jobId ?data.jobId:0;
      let candidateID=data.candidateID?data.candidateID:""
      let params =
        "jobId=" + jobId +
        "&productId="+ productId +
        "&candidateID=" + candidateID+
        "&fromDate=" + data.startDate +
        "&toDate=" + data.endDate +
        "&applicationStatus=" + data.candidateStatus +
        "&reportFlag="+ type;
        
      StudentAssessmentService.getCandidateJobDetails(
        params,
        res => {
          if (res.status === "success") {
            this.setState({ loading: true });
            this.setState({ data: res.responseListObject });
            this.setState({ loading: false });
          } else {
            this.setState({
              data: []
            });
          }
        }
      );
    });
  }
  handleUpdateStage(candidateId,partyId,jobCourse,locationMapID,type){
    if(type==="Job"){
      let jobName = jobCourse.split("|");
      let jobId = parseInt(jobName[0]);
      this.setState({
        candidateId:candidateId,
        partyId:partyId,
        isEdit: true,
        modalJobId: jobId,
        locationMapID:locationMapID,
        isButtonDisabled:false,
      })
    }
    if(type==="Course"){
      
      let courseName = jobCourse.split("|");
      let courseId = parseInt(courseName[0]);
      console.log('sunny jobCourse',jobCourse,courseName,courseId);
      this.setState({
        candidateIdCourse:candidateId,
        partyIdCourse:partyId,
        isEdit: true,
        modalCourseId: courseId,
        locationMapIDCourse:locationMapID,
        isButtonDisabled:false,
      })
    }
  }
  handleUpdateStatus(values,type){
    if(type==="Job"){
      console.log('values jobs update status',values);
      let jobName = values.job.split("|");
      let jobId = parseInt(jobName[0]);
      this.setState({
        candidateId:values.candidateID,
        partyId:values.partyID,
        isEdit: true,
        modalJobId: jobId,
        applicationId: values.applicationID,
        applicationStatus: values.applicationStatus
      })
    }
    if(type==="Course"){
      console.log('values course update status',values);
      let courseName = values.course?.split("|");
      let courseId =courseName?parseInt(courseName[0]):"---";
      this.setState({
        candidateIdCourse:values.candidateID,
        partyIdCourse:values.partyID,
        isEdit: true,
        modalCourseId: courseId,
        applicationIdCourse: values.applicationID,
        applicationStatusCourse: values.applicationStatus,
        candidateEmailId:values.emailID
      })
    } 
  } 
  handleGetJobHistory(partyid,jobCourse,locmapid,type){
    if(type==="Job"){
      console.log('values job history',partyid,jobCourse,locmapid);
      let jobName = jobCourse.split("|");
      let jobId = parseInt(jobName[0]);
      let params= `partyid=${partyid}&jobid=${jobId}&productid=&locmapid=${locmapid}`;
      StudentAssessmentService.getJobHistory(params, res => {
        if (res.status === "success") {
          this.setState({
            jobHistory: res.responseListObject ? res.responseListObject : []
          })
        }
      })
    }
    if(type==="Course"){
      console.log('values course history',partyid,jobCourse,locmapid);
      let courseName = jobCourse?.split("|");
      let courseId = courseName&&parseInt(courseName[0]);
      let params = `partyid=${partyid}&jobid=&productid=${courseId}&locmapid=`
      StudentAssessmentService.getJobHistory(params, res => {
        if (res.status === "success") {
          this.setState({
            courseHistory: res.responseListObject ? res.responseListObject : []
          })
        }
      })

    }
  }
  isValidDate = (dateString) => {
    const date = new Date(dateString);
    return !isNaN(date.getTime()); 
  };
  isRowSelected = (original) => {
  
    return this.state.selectedRecords.some((item) => item.applicationID === original.applicationID);
    
  };
  
  toggleRow = (original) => {
    const isFound = this.isRowSelected(original);
    const selectedRecords = [...this.state.selectedRecords];
  
    if (isFound) {
      this.setState({
        selectedRecords: selectedRecords.filter((item) => item.applicationID !== original.applicationID),
      });
    } else {
      selectedRecords.push(original);
      this.setState({
        selectedRecords: selectedRecords,
      });
    }
  };
  
  isSelectAllChecked = () => {
    return this.state.data.length > 0 && this.state.selectedRecords.length === this.state.data.length; 
    };
  
  toggleSelectAll = () => {
    if (this.isSelectAllChecked()) {
      this.setState({
        selectedRecords: [],
      });
    } else {
      this.setState({
        selectedRecords: this.state.data.slice(), 
      });
    }
  };
  handleNumberChange = (e,fieldId) => {
    e.preventDefault();
    const input = e.target.value.replace(/\D/g, '');
    if(["studentId"].includes(fieldId)){
      this.setState({ studentId: input });
    }else if(["jobId"].includes(fieldId)){
      this.setState({ jobId: input });
    }else if(["courseId"].includes(fieldId)){
      this.setState({ courseId: input });
    }
  }
  render() {
    console.log('state',this.state);
    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          candidateStatus: "",
          startDate: "",
          endDate: "",
          maxDate: new Date(),
          listOfMonth: this.state.listOfMonth,
          listOfDay: this.state.listOfDay,
          listOfMonth1: this.state.listOfMonth,
          listOfDay1: this.state.listOfDay,
          fromday: "",
          frommonth: "",
          fromyear: "",
          today: "",
          tomonth: "",
          toyear: "",
          searchType:this.state.searchType
        }}
        validationSchema={Yup.object().shape({
          emailId: Yup.string().email("Invalid E-Mail"),
        })}
        onSubmit={(fields) => {
          if(["",null,undefined].includes(this.state.fromday)){
            warning("You Must Specify Start Day",warningNotification);
            return;
          }
          if(["",null,undefined].includes(this.state.frommonth)){
            warning("You Must Specify Start Month",warningNotification);
            return;
          }
          if(["",null,undefined].includes(this.state.fromyear)){
            warning("You Must Specify Start Year",warningNotification);
            return;
          }
          if(["",null,undefined].includes(this.state.today1)){
            warning("You Must Specify End Day",warningNotification);
            return;
          }
          if(["",null,undefined].includes(this.state.tomonth)){
            warning("You Must Specify End Month",warningNotification);
            return;
          }
          if(["",null,undefined].includes(this.state.toyear)){
            warning("You Must Specify End Year",warningNotification);
            return;
          }
          let formattedFromDate = "";
          let formattedEndDate = "";

          if ((this.state.fromyear !== undefined && this.state.fromyear !== "") && (this.state.frommonth !== undefined && this.state.frommonth !== "") && (this.state.fromday !== undefined && this.state.fromday !== "")) {
            let fromdy = String(this.state.fromday).length == 1 ? "0" + this.state.fromday : this.state.fromday
            let frommont = String(this.state.frommonth).length == 1 ? "0" + this.state.frommonth : this.state.frommonth;
            formattedFromDate =
              fromdy + "/" + frommont + "/" + this.state.fromyear;
          } else {
            formattedFromDate = "";
          }
          if ((this.state.toyear !== undefined && this.state.toyear !== "") && (this.state.tomonth !== undefined && this.state.tomonth !== "") && (this.state.today1 !== undefined && this.state.today1 !== "")) {
            let tody = String(this.state.today1).length == 1 ? "0" + this.state.today1 : this.state.today1
            let tomont =String(this.state.tomonth).length == 1 ? "0" + this.state.tomonth : this.state.tomonth;

            formattedEndDate =
              tody + "/" + tomont + "/" + this.state.toyear;

          } else {
            formattedEndDate = "";
          }
          if(formattedEndDate !== ""){
            if(this.state.fromday === "" && this.state.frommonth === "" && this.state.fromyear === ""){
              warning('You must specify the “Start Date”',warningNotification);
              return;
            }
          }
          if(formattedFromDate !== ""){
            if(this.state.today1 === "" && this.state.tomonth === "" && this.state.toyear === ""){
              warning('You must specify the “End Date”',warningNotification);
              return;
            }
          }          
          let fromDtConverted = moment(formattedFromDate, "DD.MM.YYYY");
          let toDtConverted = moment(formattedEndDate, "DD.MM.YYYY");
          let todayConverted = moment(new Date(), "DD.MM.YYYY");
          if (!this.isValidDate(fromDtConverted)) {
            warning("Invalid Start Date",warningNotification);
            return;
          }
          if (!this.isValidDate(toDtConverted)) {
            warning("Invalid End Date",warningNotification);
            return;
          }

          if (toDtConverted.diff(fromDtConverted, 'days') < 0) {
            this.setState({ loading: false });
            warning('Start Date should not be greater than End Date', warningNotification);
          } else if (fromDtConverted.diff(todayConverted, 'days') > 0) {
            this.setState({ loading: false });
            warning('“Start Date” should be Before “Today’s Date”', warningNotification);
          } else {

            this.setState({ loading: true });
            let data ;
            if(this.state.searchType==="Job"){

               data = {
                startDate: formattedFromDate,
                endDate: formattedEndDate,
                candidateStatus: this.state.candidateStatus,
                candidateID:this.state.studentId,
                emailId: this.state.emailId,
                jobId: this.state.jobId === "" ? 0 : this.state.jobId ? this.state.jobId : 0
              };
            }
            if(this.state.searchType==="Course"){
              data = {
                startDate: formattedFromDate,
                endDate: formattedEndDate,
                candidateStatus: this.state.candidateStatus,
                candidateID:this.state.studentId,
                emailId: this.state.emailId,
                productId: this.state.courseId 
                
              };
            }

            console.log("data:: ", data)
            this.generateData(data,this.state.searchType);
            this.setState({ loading: false });
          }
        }}
        render={({ handleSubmit, handleChange, errors, touched, values, setFieldValue }) => (
          <React.Fragment>
            <AdminHeader
              {...this.props}
            />
            {this.state.loading && (
              <PopUpPortal
                HidePopup={this.state.loading}
                IsVisible={this.state.loading}
              />
            )}
            <section class="dashboard-tab user-tab pt-50 mb-50">
              <div class="padding-rl-50">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12">
                      <div class="table-header">
                        <h3>
                          <div class="row">
                            <div class="col-md-8 col-sm-6 col-xs-8">
                              <span class="left-icon">
                                <i class="fa fa-list" aria-hidden="true"></i>
                              </span>{" "}
                              Candidate {this.state.searchType} Details
                            </div>
                            <div class="col-md-4 col-sm-6 col-xs-4">
                              <span class="right-icon">
                                <a>
                                  <i onClick={() => this.exportToCSV(this.state.searchType)}
                                    class="fa fa-file-excel-o"
                                    aria-hidden="true"
                                    title="Export"
                                  ></i>
                                </a>
                              </span>
                            </div>
                          </div>
                        </h3>
                      </div>
                      <div class="bg-box">
                        <Form onSubmit={handleSubmit} className="">
                          <div class="row">
                            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                              <div className="filter">
                                <div className="form-group">
                                <div className="row">
                                  <div className="col-md-3 col-lg-3 col-sm-7 col-xs-12 ">
                                    <h5 className="filter-heading">
                                      Search Criteria
                                    </h5>
                                  </div>
                                  <div className="col-md-9 col-lg-9 col-sm-5 col-xs-12 pl pr">         
                                      <div style={{marginLeft:"20px"}}>
                                        <span className="mr-20" style={{display: "inline-flex",alignItems: "flex-end"}}>
                                          <Field
                                            type="radio"
                                            className={
                                              "form-control " +
                                              (errors.searchType && touched.searchType
                                                ? " is-invalid "
                                                : " ") +
                                              "employement-radio-input mr-10"
                                            }
                                            name="searchType"
                                            id="searchType"
                                            onChange={(e)=>{
                                              handleChange(e);
                                              this.setState({searchType:e.target.value})
                                              this.setState({ loading: true });
                                              StudentAssessmentService.getCandidateJobDetails(`candidateID=&fromDate=${this.state.fromDate}&toDate=${this.state.toDate}&jobId=0&productId=&applicationStatus=&reportFlag=JOB`, (res) => {     
                                                console.log('candidate res',res);           
                                                if (res.status === "success") {
                                                  this.setState({loading:false})
                                                  this.setState({ data: res.responseListObject ,selectedRecords:[]});
                                                  this.setState({
                                                    candidateStatus: "",
                                                    jobId: "",
                                                    courseId: "",
                                                    studentId: "",
                                                })
                                                this.handleDate();
                                                }
                                                else{
                                                  this.setState({
                                                    loading:false
                                                  })
                                                }
                                              })
                                            }}
                                            value="Job"
                                            defaultChecked={
                                              this.state.searchType === "Job"
                                            }
                                          />{" "}
                                         Job
                                        </span>
                                        <span style={{display: "inline-flex",alignItems: "flex-end"}}>
                                          <Field
                                            type="radio"
                                            className={
                                              "form-control " +
                                              (errors.searchType && touched.searchType
                                                ? " is-invalid "
                                                : " ") +
                                              "employement-radio-input mr-10"
                                            }
                                            name="searchType"
                                            id="searchType"
                                            value="Course"
                                            onChange={(e)=>{
                                              handleChange(e);
                                              this.setState({searchType:e.target.value})
                                              this.setState({ loading: true });
                                              StudentAssessmentService.getCandidateJobDetails(`candidateID=&fromDate=${this.state.fromDate}&toDate=${this.state.toDate}&jobId=0&productId=&applicationStatus=&reportFlag=COURSE`, (res) => {
      
                                                console.log('candidate res',res);
                                                
                                                if (res.status === "success") {
                                                  this.setState({loading:false})
                                                  this.setState({ data: res.responseListObject,selectedRecords:[]});
                                                  this.setState({
                                                    candidateStatus: "",
                                                    jobId: "",
                                                    courseId: "",
                                                    studentId: "",
                                                })
                                                this.handleDate();
                                                  
                                                  
                                                }
                                                else{
                                                  this.setState({ loading: false });
                                                }
                                              })
                                            }}
                                            id="searchType"
                                            defaultChecked={
                                              this.state.searchType === "Course"
                                            }
                                          />{" "}
                                          Course
                                        </span>
                                      </div>
                                     
                                      <ErrorMessage
                                        name="searchType"
                                        className="validation "
                                        component="div"
                                      /> 
                                  </div>
                                </div>
                                  <div className="row">
                                    <div className="col-md-3 col-sm-4 col-xs-12">
                                      <label>Application Status</label>
                                      <Field
                                        as="select"
                                        name="candidateStatus"
                                        id="candidateStatus"
                                        class="form-control"
                                        value={this.state.candidateStatus}
                                        onChange={e => {
                                          this.setState({
                                            candidateStatus: e.target.value
                                          })
                                        }}
                                      >
                                        <option value="">
                                          --- Select ---
                                        </option>
                                        <option value="Accepted">
                                          Accepted
                                        </option>
                                        <option value="In Process">
                                          In Process
                                        </option>
                                        <option value="Rejected">
                                          Rejected
                                        </option>
                                        {this.state.searchType==="Job"&&(
                                        <option value="Shortlisted">
                                          Shortlisted
                                        </option>
                                        )}
                                      </Field>
                                    </div>
                                    <div className="col-md-3 col-sm-4 col-xs-12">
                                      <label>Candidate Id </label>
                                      <Field
                                        type="text"
                                        name="studentId"
                                        id="studentId"
                                        maxLength={15}
                                        autoComplete="studentId"
                                        value={this.state.studentId}
                                        className={
                                          "form-control" +
                                          (errors.studentId && touched.studentId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        // onChange={(e)=>{
                                        //   handleChange(e);
                                        //   this.setState({ studentId: e.target.value })
                                        // }}
                                        onChange={(e)=>{ handleChange(e);
                                          this.handleNumberChange(e,"studentId");
                                        }}
                                        // onPaste={(e) => e.preventDefault()}
                                        placeholder="Candidate Id"
                                      />
                                      <ErrorMessage
                                        name="studentId"
                                        component="div"
                                        className="validation"
                                      />

                                    </div>
                                    <div className="col-md-3 col-sm-4 col-xs-12">
                                      <label>Start Date
                                            {" "}
                                        <span className="validation"> *</span> 
                                      </label>

                                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                        <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                          <Field
                                            as="select"
                                            name="fromday"
                                            id="fromday"
                                            value={this.state.fromday}
                                            onChange={(e) => {
                                              var listOfMonth = [];
                                              this.setState({
                                                fromday: e.target.value
                                              })
                                              if (e.target.value == 31) {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 5, value: "May" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              } else if (e.target.value == 30) {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 4, value: "Apr" },
                                                  { key: 5, value: "May" },
                                                  { key: 6, value: "Jun" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 9, value: "Sep" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 11, value: "Nov" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              } else if (
                                                e.target.value == 28 ||
                                                e.target.value == 29
                                              ) {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 2, value: "Feb" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 4, value: "Apr" },
                                                  { key: 5, value: "May" },
                                                  { key: 6, value: "Jun" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 9, value: "Sep" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 11, value: "Nov" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              } else {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 2, value: "Feb" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 4, value: "Apr" },
                                                  { key: 5, value: "May" },
                                                  { key: 6, value: "Jun" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 9, value: "Sep" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 11, value: "Nov" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              }
                                              setFieldValue((values.listOfMonth = listOfMonth));
                                            }}
                                            className={"form-control" + (errors.fromday && touched.fromday ? "is-invalid" : "")}
                                            className="form-control"
                                          >
                                            <option value="">DD</option>
                                            {
                                              (values.listOfDay || []).map(
                                                (d) => (<option value={d}> {d} </option>
                                                )
                                              )}
                                          </Field>
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                          <Field
                                            as="select"
                                            name="frommonth"
                                            id="frommonth"
                                            value={this.state.frommonth}
                                            onChange={(e) => {
                                              this.setState({
                                                frommonth: e.target.value
                                              })
                                              if (e.target.value == 2) {
                                                var listOfDay = [];
                                                for (var i = 1; i <= 29; i++) {
                                                  listOfDay.push(i);
                                                }
                                              } else if (
                                                e.target.value == 1 ||
                                                e.target.value == 3 ||
                                                e.target.value == 5 ||
                                                e.target.value == 7 ||
                                                e.target.value == 8 ||
                                                e.target.value == 10 ||
                                                e.target.value == 12
                                              ) {
                                                listOfDay = [];
                                                for (var ldd = 1; ldd <= 31; ldd++) {
                                                  listOfDay.push(ldd);
                                                }
                                              } else {
                                                listOfDay = [];
                                                for (var lod = 1; lod <= 30; lod++) {
                                                  listOfDay.push(lod);
                                                }
                                              }
                                              setFieldValue((values.listOfDay = listOfDay));
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.month && touched.month
                                                ? "is-invalid"
                                                : "")
                                            }
                                            className="form-control"
                                          >
                                            <option value="">MM</option>
                                            {(values.listOfMonth || []).map(
                                              (m) => (
                                                <option value={m.key}>
                                                  {m.value}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                        </div>
                                        <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                          <Field
                                            as="select"
                                            name="fromyear"
                                            id="fromyear"
                                            value={this.state.fromyear}
                                            onChange={(e) => {
                                              this.setState({
                                                fromyear: e.target.value
                                              })
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.fromyear && touched.fromyear ? "is-invalid" : "")
                                            }
                                            className="form-control"
                                          >
                                            <option value="">YYYY</option>
                                            {(
                                              this.state.listOfYear || []
                                            ).map((year) => (
                                              <option value={year}>
                                                {year}
                                              </option>
                                            ))}
                                          </Field>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-3 col-sm-4 col-xs-12">
                                      <label>End Date{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                        <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                          <Field
                                            as="select"
                                            name="today"
                                            id="today"
                                            value={this.state.today1}
                                            onChange={(e) => {
                                              var listOfMonth = [];
                                              this.setState({
                                                today1: e.target.value
                                              })
                                              if (e.target.value == 31) {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 5, value: "May" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              } else if (
                                                e.target.value == 30
                                              ) {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 4, value: "Apr" },
                                                  { key: 5, value: "May" },
                                                  { key: 6, value: "Jun" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 9, value: "Sep" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 11, value: "Nov" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              } else if (
                                                e.target.value == 28 ||
                                                e.target.value == 29
                                              ) {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 2, value: "Feb" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 4, value: "Apr" },
                                                  { key: 5, value: "May" },
                                                  { key: 6, value: "Jun" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 9, value: "Sep" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 11, value: "Nov" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              } else {
                                                listOfMonth = [
                                                  { key: 1, value: "Jan" },
                                                  { key: 2, value: "Feb" },
                                                  { key: 3, value: "Mar" },
                                                  { key: 4, value: "Apr" },
                                                  { key: 5, value: "May" },
                                                  { key: 6, value: "Jun" },
                                                  { key: 7, value: "Jul" },
                                                  { key: 8, value: "Aug" },
                                                  { key: 9, value: "Sep" },
                                                  { key: 10, value: "Oct" },
                                                  { key: 11, value: "Nov" },
                                                  { key: 12, value: "Dec" },
                                                ];
                                              }
                                              setFieldValue((values.listOfMonth1 = listOfMonth));
                                            }}
                                            className={"form-control" + (errors.today && touched.today ? "is-invalid" : "")}
                                            className="form-control"
                                          >
                                            <option value="">DD</option>
                                            {(values.listOfDay1 || []).map(
                                              (d) => (<option value={d}> {d} </option>
                                              )
                                            )}
                                          </Field>
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                          <Field
                                            as="select"
                                            name="tomonth"
                                            id="tomonth"
                                            value={this.state.tomonth}
                                            onChange={(e) => {
                                              this.setState({
                                                tomonth: e.target.value
                                              })
                                              if (e.target.value == 2) {
                                                var listOfDay = [];
                                                for (var i = 1; i <= 29; i++) {
                                                  listOfDay.push(i);
                                                }
                                              } else if (
                                                e.target.value == 1 ||
                                                e.target.value == 3 ||
                                                e.target.value == 5 ||
                                                e.target.value == 7 ||
                                                e.target.value == 8 ||
                                                e.target.value == 10 ||
                                                e.target.value == 12
                                              ) {
                                                listOfDay = [];
                                                for (var ldd = 1; ldd <= 31; ldd++) {
                                                  listOfDay.push(ldd);
                                                }
                                              } else {
                                                listOfDay = [];
                                                for (var lod = 1; lod <= 30; lod++) {
                                                  listOfDay.push(lod);
                                                }
                                              }
                                              setFieldValue((values.listOfDay1 = listOfDay));
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.tomonth && touched.tomonth
                                                ? "is-invalid"
                                                : "")
                                            }
                                            className="form-control"
                                          >
                                            <option value="">MM</option>
                                            {(values.listOfMonth1 || []).map(
                                              (m) => (
                                                <option value={m.key}>
                                                  {m.value}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                        </div>
                                        <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                          <Field
                                            as="select"
                                            name="toyear"
                                            id="toyear"
                                            value={this.state.toyear}
                                            onChange={(e) => {
                                              this.setState({
                                                toyear: e.target.value
                                              })
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.toyear && touched.toyear ? "is-invalid" : "")
                                            }
                                            className="form-control"
                                          >
                                            <option value="">YYYY</option>
                                            {(
                                              this.state.listOfYear1 || []
                                            ).map((year) => (
                                              <option value={year}>
                                                {year}
                                              </option>
                                            ))}
                                          </Field>
                                        </div>
                                      </div>
                                    </div>
                                    {this.state.searchType==="Job"&&(
                                    <div className="col-md-3 col-sm-4 col-xs-12">
                                      <label>Job Id</label>
                                      <Field
                                        type="text"
                                        name="jobId"
                                        id="jobId"
                                        maxLength={9}
                                        autoComplete="jobId"
                                        value={this.state.jobId}
                                        className={
                                          "form-control" +
                                          (errors.jobId && touched.jobId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Job ID"
                                        // onChange={(e)=>{
                                        //   handleChange(e);
                                        //   this.setState({ jobId: e.target.value })
                                        // }}
                                        onChange={(e)=>{ handleChange(e);
                                          this.handleNumberChange(e,"jobId");
                                        }}
                                        // onPaste={(e) => e.preventDefault()}
                                      />
                                      <ErrorMessage
                                        name="jobId"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    )}
                                {this.state.searchType==="Course"&&(
                                      <div className="col-md-3 col-sm-4 col-xs-12">
                                      <label>Course Id</label>
                                      <Field
                                        type="text"
                                        name="courseId"
                                        id="courseId"
                                        maxLength={15}
                                        autoComplete="courseId"
                                        value={this.state.courseId}
                                        className={
                                          "form-control" +
                                          (errors.courseId && touched.courseId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Course ID"
                                        // onChange={(e)=>{
                                        //   handleChange(e);
                                        //   this.setState({ courseId: e.target.value })
                                        // }}
                                        onChange={(e)=>{ handleChange(e);
                                          this.handleNumberChange(e,"courseId");
                                        }}
                                        // onPaste={(e) => e.preventDefault()}
                                      />
                                      <ErrorMessage
                                        name="courseId"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                )}
                                  </div>
                                  <div class="row">
                                    <div className="col-md-12 col-sm-12 mt-40">
                                      <button
                                        className="btn-5 mr-20 ml-20"
                                        type="submit"
                                      >
                                        Search
                                      </button>
                                      <button
                                        className="btn-5"
                                        type="reset"
                                        onClick={this.showAll}
                                      >
                                        Reset
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                        {this.state.searchType==="Job"&&(
                        <div class="table-responsive">
                          <ReactTable
                            minRows={2}
                            data={this.state.data || []}
                            filterable
                            ref={(refReactTable) => { this.refReactTable = refReactTable; }}
                            defaultFilterMethod={this.filterCaseInsensitive}

                            columns={[
                              {                        
                                columns: [
                                 
                                  // {
                                  //   id: "checkbox",
                                  //   accessor: "",
                                  //   Cell: ({ original }) => {
                                  //     return (
                                  //       <input
                                  //         type="checkbox"
                                  //         className="checkbox"
                                  //         checked={this.isRowSelected(original)}
                                  //         onChange={() => this.toggleRow(original)}
                                  //       />
                                  //     );
                                  //   },
                                  //   Header: () => {
                                  //     return (
                                  //       <input
                                  //         type="checkbox"
                                  //         className="checkbox"
                                  //         checked={this.isSelectAllChecked()}
                                  //         onChange={this.toggleSelectAll}
                                  //       />
                                  //     );
                                  //   },
                                  //   sortable: false,
                                  //   filterable: false,
                                  //   width: 45,
                                  // },
                                  {
                                    Header: "Candidate",
                                    id: "candidateID",
                                    accessor: d => d.candidateID ? d.candidateID : '---',
                                    Cell: (props) => {
                                      return (
                                      <span title={props.original.candidateID ? props.original.candidateID.toString() : "---"}>
                                        {props.original.candidateID ? props.original.candidateID.toString() : "---"}</span>
                                      );
                                    },
                                  },
                                  {
                                    Header: "Corporate",
                                    id: "corporate",
                                    accessor: d => d.corporate ? d.corporate : '---',
                                    Cell: (props) => {
                                      return (
                                      <span title={props.original.corporate ? props.original.corporate.toString() : "---"}>
                                        {props.original.corporate ? props.original.corporate.toString() : "---"}</span>
                                      );
                                    },
                                  },
                                  {
                                    Header: "Mobile No",
                                    id: "mobileNo",
                                    accessor: d => (d.mobileNo ? d.mobileNo : '---').toString(),
                                  },
                                  {
                                    Header: "Job",
                                    id: "job",
                                    accessor: d => d.job ? d.job : "---",
                                    Cell: (props) => {
                                      return (
                                      <span title={props.original.job ? props.original.job.toString() : "---"}>
                                        {props.original.job ? props.original.job.toString() : "---"}</span>
                                      );
                                    },
                                  },
                                  {
                                    Header: "Location",
                                    id: "locationName",
                                    accessor: d => d.locationName ? d.locationName : '---',
                                    Cell: (props) => {
                                      return (
                                      <span title={props.original.locationName ? props.original.locationName.toString() : "---"}>
                                        {props.original.locationName ? props.original.locationName.toString() : "---"}</span>
                                      );
                                    },
                                  },
                                  {
                                    Header: "Applied Date",
                                    id: "appliedDate",
                                    accessor: (d) => (d.appliedDate ? d.appliedDate : '---').toString(),
                                  },
                                  {
                                    Header: "Application Status",
                                    id: "applicationStatus",
                                    accessor: (d) => (d.applicationStatus ? d.applicationStatus : '---').toString(),
                                  },
                                  {
                                    Header: "5Qs - Pass / Fail",
                                    id: "result",
                                    accessor: d => (d.result ? d.result : '---').toString(),
                                  },
                                  {
                                    Header: "Update Stage",
                                    id: "updateStage",
                                    filterable: false,
                                    sortable: false,
                                    accessor: d => 
                                    d.applicationStatus === "In Process" 
                                    ? (
                                      <a
                                        data-toggle="modal"
                                        data-target="#updateStageModal"
                                        href="#"
                                        onClick={() => {
                                           this.handleUpdateStage(d.candidateID,d.partyID,
                                            d.job,d.locationMapID,"Job")
                                        }}
                                      >
                                        {" "}
                                        Display
                                      </a>
                                    )
                                     : "---",
                                  },
                                  {
                                    Header: "Update Status",
                                    id: "updateStatus",
                                    filterable: false,
                                    sortable: false,
                                    Cell: (props) => {
                                      return (
                                        <div>
                                          <a className=""  href="#" data-toggle="modal"
                                        data-target="#statusModal" onClick={()=>{
                                          this.handleUpdateStatus(props.original,"Job")
                                        }}>
                                            Update
                                          </a>
                                        </div>
                                      );
                                    },
                                  },
                                  {
                                    Header: "History",
                                    id: "history",
                                    filterable: false,
                                    sortable: false,
                                    accessor: d => 
                                    d.applicationStatus === "In Process" 
                                    ? (
                                      <a
                                        data-toggle="modal"
                                        data-target="#historyModal"
                                        href="#"
                                        onClick={() => {
                                           this.handleGetJobHistory(d.partyID,
                                            d.job,d.locationMapID,this.state.searchType)
                                        }}
                                      >
                                        {" "}
                                        Display
                                      </a>
                                    )
                                     : "---",
                                  },
                                ]
                              }
                            ]}
                            defaultPageSize={20}
                            style={{
                              width: "100%",
                              maxHeight: "500px"
                            }}
                          />
                        </div>
                          )}  
                        {this.state.searchType==="Course"&&(
                        <div class="table-responsive">
                          <ReactTable
                            minRows={2}
                            data={this.state.data || []}
                            filterable
                            ref={(refReactTable) => { this.refReactTable = refReactTable; }}
                            defaultFilterMethod={this.filterCaseInsensitive}

                            columns={[
                              {                        
                                columns: [
                                  // {
                                  //   id: "checkbox",
                                  //   accessor: "",
                                  //   Cell: ({ original }) => {
                                  //     return (
                                  //       <input
                                  //         type="checkbox"
                                  //         className="checkbox"
                                  //         checked={this.isRowSelected(original)}
                                  //         onChange={() => this.toggleRow(original)}
                                  //       />
                                  //     );
                                  //   },
                                  //   Header: () => {
                                  //     return (
                                  //       <input
                                  //         type="checkbox"
                                  //         className="checkbox"
                                  //         checked={this.isSelectAllChecked()}
                                  //         onChange={this.toggleSelectAll}
                                  //       />
                                  //     );
                                  //   },
                                  //   sortable: false,
                                  //   filterable: false,
                                  //   width: 45,
                                  // },
                                  {
                                    Header: "Candidate",
                                    id: "candidateID",
                                    accessor: d => d?.candidateID ? d?.candidateID : '---',
                                    Cell: (props) => {
                                      return (
                                      <span title={props.original?.candidateID ? props.original?.candidateID.toString() : "---"}>
                                        {props.original?.candidateID ? props.original?.candidateID.toString() : "---"}</span>
                                      );
                                    },
                                  },
                                  {
                                    Header: "Mobile No",
                                    id: "mobileNo",
                                    accessor: d => (d?.mobileNo ? d?.mobileNo : '---').toString(),
                                  },
                                  {
                                    Header: "Course",
                                    id: "course",
                                    accessor: d => d?.course ? d?.course : "---",
                                    Cell: (props) => {
                                      return (
                                      <span title={props.original?.course ? props.original?.course.toString() : "---"}>
                                        {props.original?.course ? props.original?.course.toString() : "---"}</span>
                                      );
                                    },
                                  },
                                  {
                                    Header: "Applied Date",
                                    id: "appliedDate",
                                    accessor: (d) => (d?.appliedDate ? d?.appliedDate : '---').toString(),
                                  },
                                  {
                                    Header: "Application Status",
                                    id: "applicationStatus",
                                    accessor: (d) => (d?.applicationStatus ? d?.applicationStatus : '---').toString(),
                                  },
                                  {
                                    Header: "5Qs - Pass / Fail",
                                    id: "result",
                                    accessor: d => (d?.result ? d?.result : '---').toString(),
                                  },
                                  {
                                    Header: "Update Stage",
                                    id: "updateStage",
                                    filterable: false,
                                    sortable: false,
                                    accessor: d => 
                                    d?.applicationStatus === "In Process" 
                                    ? (
                                      <a
                                        data-toggle="modal"
                                        data-target="#updateStageModal"
                                        href="#"
                                        onClick={() => {
                                           this.handleUpdateStage(d.candidateID,d.partyID,
                                            d.course,d.locationMapID,"Course")
                                        }}
                                      >
                                        {" "}
                                        Display
                                      </a>
                                    )
                                     : "---",
                                  },
                                  {
                                    Header: "Update Status",
                                    id: "updateStatus",
                                    filterable: false,
                                    sortable: false,
                                    accessor: d => 
                                    d?.applicationStatus === "In Process" 
                                    ? (
                                      <a className=""  href="#" data-toggle="modal"
                                      data-target="#statusModal" onClick={()=>{
                                        this.handleUpdateStatus(d,"Course")
                                      }}>
                                          Update
                                        </a>
                                    )
                                     : "---",
                                  },
                                  {
                                    Header: "History",
                                    id: "history",
                                    filterable: false,
                                    sortable: false,
                                    accessor: d => 
                                    d.applicationStatus === "In Process" 
                                    ? (
                                      <a
                                        data-toggle="modal"
                                        data-target="#historyModal"
                                        href="#"
                                        onClick={() => {
                                           this.handleGetJobHistory(d.partyID,
                                            d.course,d.locationMapID,this.state.searchType)
                                        }}
                                      >
                                        {" "}
                                        Display
                                      </a>
                                    )
                                     : "---",
                                  },
                                ]
                              }
                            ]}
                            defaultPageSize={20}
                            style={{
                              width: "100%",
                              maxHeight: "500px"
                            }}
                          />
                        </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* <!-- Update Stage Modal Starts  --> */}

            <Formik
              enableReinitialize={true}
              initialValues={{
                candidateId:this.state.searchType==="Job"?this.state.candidateId:this.state.searchType==="Course"?this.state.candidateIdCourse:"",
                partyId:this.state.searchType==="Job"?this.state.partyId:this.state.searchType==="Course"?this.state.partyIdCourse:"",
                jobId:this.state.searchType==="Job"?this.state.modalJobId:this.state.searchType==="Course"?this.state.modalCourseId:"",
                locationMapID:this.state.searchType==="Job"?this.state.locationMapID:this.state.searchType==="Course"?this.state.locationMapIDCourse:"",
                stageType:"",
                stageName:"",
                stageDate:"",
                stageTime:"",
                stageInterviewer:"",
                stageLink:"",
                stageAddress:"",
                stageGoogleMapLink:"",
                stageComment:"",
                today: new Date().toISOString().split('T')[0],
                searchType:this.state.searchType
                
              }}
              validationSchema={Yup.object().shape({
                candidateId: Yup.string().required("You must specify a Candidate"),
                stageType: Yup.string().required("You must specify a Stage Type"),
                stageDate: Yup.string().required("You must specify a Stage Date"),
                stageTime: Yup.string().required("You must specify a Stage Time"),
                stageInterviewer: Yup.string().when('searchType', {
                  is: (searchType) => searchType === 'Job',
                  then: Yup.string()
                    .required('You must specify a Stage Interviewer')
                    .matches(
                      /^[a-zA-Z0-9.]+[a-zA-Z0-9\s.]*$/,
                      'First Space is Not Allowed, Only AlphaNumeric, Dot(.), Spaces are allowed.'
                    ),
                  otherwise: Yup.string()
                    .required('You must specify a Stage Approver')
                    .matches(
                      /^[a-zA-Z0-9.]+[a-zA-Z0-9\s.]*$/,
                      'First Space is Not Allowed, Only AlphaNumeric, Dot(.), Spaces are allowed.'
                    ),
                }),
                stageComment: Yup.string().matches(/^[a-zA-Z0-9.]+[a-zA-Z0-9\s.]*$/,"First Space is Not Allowed , Only AlphaNumeric, Dot(.), Spaces are allowed."),
                stageLink: Yup.string().when("stageType",{
                  is: (stageType) => (stageType === "2" ? true : false),
                  then: Yup.string().required("You must specify a Stage Link"),
                  otherwise: Yup.string(),    
                }),
                stageAddress: Yup.string().when("stageType",{
                  is: (stageType) => (["3","4","6"].includes(stageType) ? true : false),
                  then: Yup.string().required("You must specify a Stage Address")
                  .matches(/^[a-zA-Z0-9-./,]+[a-zA-Z0-9-\s./,]*$/,"First Space is Not Allowed , Only AlphaNumeric, Dot(.),Hyphen(-),Comma(-),Slash(/), Spaces are allowed."),
                  otherwise: Yup.string(),    
                }),
                stageGoogleMapLink: Yup.string().when("stageType",{
                  is: (stageType) => (["3","4","6"].includes(stageType) ? true : false),
                  then: Yup.string().required("You must specify a Stage Map Link"),
                  otherwise: Yup.string(),    
                }),
              })}
              onSubmit={(values)=>{
                console.log('stage fields values',values);
                
                let dateStage = values.stageDate;
                let dateStage1 = dateStage.split("-");
                console.log('dateStage1',dateStage1);
                let stageDate = `${dateStage1[2]}/${dateStage1[1]}/${dateStage1[0]} ${values.stageTime}:00`
                let stageDate1 = `${dateStage1[2]}/${dateStage1[1]}/${dateStage1[0]}`
                console.log('stageDate',stageDate);

                //! UTC Time (5:30)Regarding Time Change Starts
                const currentDate = new Date(values.stageDate);
                const day = String(currentDate.getDate()).padStart(2, '0');
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const year = currentDate.getFullYear();
                const eventDate = `${month}/${day}/${year} ${values.stageTime}:00`;
                console.log('eventDate',eventDate);

                var dateUTC = new Date(eventDate);
                console.log('dateUTC',dateUTC);
                var dateUTC1 = dateUTC.getTime() 
                console.log('dateUTC1',dateUTC1);
                
                var dateIST = new Date(dateUTC1);
                console.log('dateIST',dateIST); 
                dateIST.setHours(dateIST.getHours() + 5); 
                dateIST.setMinutes(dateIST.getMinutes() + 30);
                let tt = new Date(dateIST)
                console.log('tt',tt);
                const day1 = String(tt.getDate()).padStart(2, '0');
                const month1 = String(tt.getMonth() + 1).padStart(2, '0');
                const year1 = tt.getFullYear();
                const hr = String(tt.getHours());
                const min = String(tt.getMinutes());
                const sec = String(tt.getSeconds());

                const eventDate1 = `${day1}/${month1}/${year1} ${hr}:${min}:${sec}`;
                console.log('eventDate1',eventDate1);
                //! UTC Time (5:30)Regarding Time Change Ends                

                let fromDtConverted = moment(stageDate1, "DD.MM.YYYY");
                let todayConverted = moment(new Date().toLocaleDateString(), "DD.MM.YYYY");
                
                if (todayConverted.diff(fromDtConverted, 'days') === 0) {
                  let stageTime1 = values.stageTime.split(":")
          
                  let stageTimeHour = parseInt(stageTime1[0])
                  let stageTimeMinute = parseInt(stageTime1[1])
                  let todayDateHour = new Date().getHours()
                  let todayDateMinute = new Date().getMinutes()
                  
                  if(todayDateHour > stageTimeHour){
                  this.setState({ loading: false });
                  warning("This Time cannot be selected", warningNotification);  
                  return
                  }else if(todayDateHour === stageTimeHour){
                    if(todayDateMinute > stageTimeMinute){
                      this.setState({ loading: false });
                      warning("This Time cannot be selected", warningNotification);  
                      return
                      } 
                  }
                  return
                }
                console.log('stageDate',stageDate);
                this.setState({ loading : true,isButtonDisabled:true})
                //! Stage Update Payload
                let data ;
                if(this.state.searchType==="Job"){

                  data = {
                    jobID: values.jobId,
                    partyID: values.partyId,
                    stageName: values.stageName ? values.stageName : "",
                    stageTypeID: values.stageType ? parseInt(values.stageType) : "",
                    stageDate: eventDate1,
                    interviewer: values.stageInterviewer ? values.stageInterviewer : "",
                    comment: values.stageComment ? values.stageComment : "",
                    docID: null,
                    docUrl: null,
                    locationMapID: values.locationMapID,
                    stageLink: values.stageLink ? values.stageLink : "",
                    stageLocation: values.stageAddress ? values.stageAddress : "",
                    stageLocationLink: values.stageGoogleMapLink ? values.stageGoogleMapLink : ""
                  }
                }
                if(this.state.searchType==="Course"){
                 
                  data = {
                    productID: values.jobId,
                    partyID: values.partyId,
                    stageName: values.stageName ? values.stageName : "",
                    stageTypeID: values.stageType ? parseInt(values.stageType) : "",
                    stageDate: eventDate1,
                    interviewer: values.stageInterviewer ? values.stageInterviewer : "",
                    comment: values.stageComment ? values.stageComment : "",
                  }
                }

                console.log('updateStage data',data);
                if(this.state.searchType==="Job"){
                  StudentAssessmentService.saveStageUpdateForJob(data, res => {
                    console.log('updateStage res',res);
                    
                    if (res.status === "success") {
                      let attendeesEmailList = res.responseObject.calenderAndEventsModel.participantsList.map((data) => {
                        let participantsListObject = {
                          email: data.inviteeEmailID,
                        };
                        return participantsListObject;
                      });
                      let startDate = res.responseObject.calenderAndEventsModel.eventStartDate.split(" ");
                      let startDate1 = startDate[0].split("/");
                      let formattedStartDate = `${startDate1[2]}-${startDate1[1]}-${startDate1[0]}`;
                      let endDate = res.responseObject.calenderAndEventsModel.eventEndDate.split(" ");
                      let endDate1 = endDate[0].split("/");
                      let formattedEndDate = `${endDate1[2]}-${endDate1[1]}-${endDate1[0]}`;                    
                  
                      //! Google Calendar Event Payload 
                      let data1 = {
                        start: {
                          dateTime:`${formattedStartDate}T${res.responseObject.calenderAndEventsModel.eventStartTime}`,
                          timeZone: "Asia/Kolkata",
                        },
                        end: {
                          dateTime:`${formattedEndDate}T${res.responseObject.calenderAndEventsModel.eventEndTime}`,
                          timeZone: "Asia/Kolkata",
                        },                      
                        summary: res.responseObject.calenderAndEventsModel.eventTitle,
                        location: res.responseObject.calenderAndEventsModel.eventLocation,
                        description: res.responseObject.calenderAndEventsModel.eventDescription,
                        recurrence: [`RRULE:FREQ=DAILY;COUNT=1`],
                        attendees: attendeesEmailList,
                        reminders: {
                          useDefault: true,
                        },
                      };
                      console.log('data1',data1);
                      success("Stage Updated successfully. ", successNotification) 
                      setTimeout(()=>{
                      this.addEventToCalander(data1);  
                      },3000) 
                      this.setState({ loading : false,isButtonDisabled:true})  
                      setTimeout(()=>{
                        window.$("#updateStageModal").modal("hide");
                        values.stageType="";
                        values.stageName="";
                        values.stageDate="";
                        values.stageTime="";
                        values.stageInterviewer="";
                        values.stageLink="";
                        values.stageAddress="";
                        values.stageGoogleMapLink="";
                        values.stageComment="";
                      },1000)
                    } else {
                      warning(res.reasonText, {
                        ...warningNotification,
                        container: "top-center",
                      });
                      this.setState({ loading : false,isButtonDisabled:false})
                    }
                  }) 
                }
                else if(this.state.searchType==="Course"){

                  StudentAssessmentService.saveStageUpdateForCourse(data, res => {
                    console.log('updateStage res',res);
                    
                    if (res.status === "success") {
                      success("Stage Updated successfully. ", successNotification) 
                      this.setState({ loading : false,isButtonDisabled:true})  
                      setTimeout(()=>{
                        window.$("#updateStageModal").modal("hide");
                        values.stageType="";
                        values.stageName="";
                        values.stageDate="";
                        values.stageTime="";
                        values.stageInterviewer="";
                        values.stageLink="";
                        values.stageAddress="";
                        values.stageGoogleMapLink="";
                        values.stageComment="";
                      },1000)
                    } else {
                      warning(res.reasonText, {
                        ...warningNotification,
                        container: "top-center",
                      });
                      this.setState({ loading : false,isButtonDisabled:false})
                    }
                  })       
                }
              }}
              render={({
                errors,
                touched,
                handleSubmit,
                setFieldValue,
                handleReset,
                values,
                handleChange,
              }) => (
                  <React.Fragment>
                    <div
                      className="modal fade"
                      id="updateStageModal"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="myModalLabel"
                    >
                      <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                              onClick={handleReset}
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 className="modal-title" id="myModalLabel">
                              Update Stage
                            </h4>
                          </div>
                          <div className="modal-body">
                            <Form>
                              <div className="form-group">
                                <div className="row">
                                  <div className="col-md-6 col-sm-6 col-xs-12">
                                      <label>
                                        Candidate {" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="candidateId"
                                        id="candidateId"
                                        onChange={() => {
                                          if (!this.state.isEdit) handleChange();
                                        }}
                                        value={values.candidateId}
                                        placeholder="Candidate "
                                        disabled
                                        className={
                                          "form-control" +
                                          (errors.candidateId &&
                                          touched.candidateId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        style={{border:"1px solid #fbc583"}}
                                      />
                                      <ErrorMessage
                                        name="candidateId"
                                        className="validation "
                                        component="div"
                                      />
                                  </div>
                                  <div className="col-md-6 col-sm-6 col-xs-12">
                                  <label>
                                        Stage{" "}
                                        <span className="validation"> *</span>{" "}
                                      </label>
                                      <Field
                                        as="select"
                                        name="stageType"
                                        id="stageType"
                                        onChange={(e)=>{handleChange(e);
                                          if(e.target.value !== ""){
                                            setFieldValue("stageName",e.target.selectedOptions[0].label)
                                          }else{
                                            setFieldValue("stageName","")
                                          }
                                        if(["1"].includes(e.target.value)){
                                          setFieldValue("stageLink","");
                                          setFieldValue("stageAddress","");
                                          setFieldValue("stageGoogleMapLink","");
                                        }else if(["2"].includes(e.target.value)){
                                          setFieldValue("stageAddress","");
                                          setFieldValue("stageGoogleMapLink","");
                                        }else if(!["2"].includes(e.target.value)){
                                          setFieldValue("stageLink","");
                                        }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.stageType && touched.stageType
                                            ? " is-invalid"
                                            : "")
                                        }
                                        style={{border:"1px solid #fbc583"}}
                                      >
                                      <>
                                        <option value="">-- Select --</option>
                                      {
                                        this.state.searchType==="Job"?
                                       (this.state.InterviewStageList || []).map(
                                          (stage) => (
                                            <option
                                              key={stage.stageTypeId}
                                              value={stage.stageTypeId}
                                            >
                                              {stage.stageTypeName}
                                            </option>
                                          )
                                        )
                                        :
                                        this.state.searchType==="Course"?
                                        (this.state.InterviewStageListForCourse || []).map(
                                          (stage) => (
                                            <option
                                              key={stage.stageTypeId}
                                              value={stage.stageTypeId}
                                            >
                                              {stage.stageTypeName}
                                            </option>
                                          )
                                        )
                                          
                                          :""
                                          }
                                        </>
                                      </Field>
                                      <ErrorMessage
                                        name="stageType"
                                        component="div"
                                        className="validation"
                                      />
                                      </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-6 col-sm-6 col-xs-12">
                                  <label>
                                    Date{" "}
                                    <span className="validation"> *</span>
                                  </label>
                                  <Field
                                    type="date"
                                    name="stageDate"
                                    id="stageDate"
                                    min={values.today}
                                    onChange={handleChange}
                                    placeholder="Stage Date"
                                    style={{border:"1px solid #fbc583"}}
                                    className={
                                      "form-control " +
                                      (errors.stageDate &&
                                      touched.stageDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name="stageDate"
                                    className="validation"
                                    component="div"
                                  />
                                  </div>
                                  <div className="col-md-6 col-sm-6 col-xs-12">
                                  <label>
                                    Time{" "}
                                    <span className="validation"> *</span>
                                  </label>
                                  <Field
                                    type="time"
                                    name="stageTime"
                                    id="stageTime"
                                    onChange={handleChange}
                                    placeholder="Stage Time"
                                    style={{border:"1px solid #fbc583"}}
                                    className={
                                      "form-control " +
                                      (errors.stageTime &&
                                      touched.stageTime
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name="stageTime"
                                    className="validation"
                                    component="div"
                                  />
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-6 col-sm-6 col-xs-12">
                                    <label>Comment</label>
                                    <Field
                                      rows="3"
                                      component="textarea"
                                      maxLength={255}
                                      name="stageComment"
                                      id="stageComment"
                                      title={values.stageComment}
                                      onChange={handleChange}
                                      autoComplete="stageComment"
                                      placeholder="Stage Comment"
                                      className={
                                        "form-control" +
                                        (errors.stageComment &&
                                        touched.stageComment
                                          ? " is-invalid"
                                          : "")
                                      }
                                      style={{border:"1px solid #fbc583"}}
                                    />
                                    <ErrorMessage
                                      name="stageComment"
                                      className="validation"
                                      component="div"
                                    />
                                  </div>
                                  <div className="col-md-6 col-sm-6 col-xs-12">
                                    {this.state.searchType==="Job"?<label>
                                      Interviewer{" "}
                                      <span className="validation"> *</span>
                                    </label>:this.state.searchType==="Course"? <label>
                                      Approver{" "}
                                      <span className="validation"> *</span>
                                    </label>:
                                    <label>
                                    Interviewer{" "}
                                    <span className="validation"> *</span>
                                   </label>
                                    }
                                    <Field
                                      type="text"
                                      maxLength={255}
                                      name="stageInterviewer"
                                      id="stageInterviewer"
                                      onChange={handleChange}
                                      title={values.stageInterviewer}
                                      // placeholder="Stage Interviewer"
                                      placeholder={
                                        this.state.searchType==="Job" ? "Stage Interviewer"
                                        : this.state.searchType==="Course" ? "Stage Approver"
                                        : "Stage Interviewer"
                                      }
                                      className={
                                        "form-control" +
                                        (errors.stageInterviewer &&
                                        touched.stageInterviewer
                                          ? " is-invalid"
                                          : "")
                                      }
                                      style={{border:"1px solid #fbc583"}}
                                    />
                                    <ErrorMessage
                                      name="stageInterviewer"
                                      className="validation "
                                      component="div"
                                    />
                                  </div>
                                </div>   
                                <div className="row">
                                  {values.stageType === "2" && this.state.searchType==="Job"&&(
                                <div className="col-md-6 col-sm-6 col-xs-12">
                                  <label>
                                    Link{" "}
                                    <span className="validation"> *</span>{" "}
                                  </label>
                                  <Field
                                    // type="text"
                                    rows="3"
                                    component="textarea"
                                    name="stageLink"
                                    id="stageLink"
                                    maxLength={100}
                                    title={values.stageLink}
                                    onChange={handleChange}
                                    placeholder="Stage Link"
                                    className={
                                      "form-control" +
                                      (errors.stageLink &&
                                      touched.stageLink
                                        ? " is-invalid"
                                        : "")
                                    }
                                    style={{border:"1px solid #fbc583"}}
                                  />
                                  <ErrorMessage
                                    name="stageLink"
                                    component="div"
                                    className="validation"
                                  />
                                  </div>)}
                                   {["3","4","6"].includes(values.stageType) &&this.state.searchType==="Job"&&(
                                     <>
                                     <div className="col-md-6 col-sm-6 col-xs-12">
                                     <label>
                                       Address{" "}
                                       <span className="validation"> *</span>{" "}
                                     </label>
                                     <Field
                                       rows="3"
                                       component="textarea"
                                       name="stageAddress"
                                       id="stageAddress"
                                       maxLength={255}
                                       title={values.stageAddress}
                                       onChange={handleChange}
                                       placeholder="Stage Address"
                                       className={
                                         "form-control" +
                                         (errors.stageAddress &&
                                         touched.stageAddress
                                           ? " is-invalid"
                                           : "")
                                       }
                                       style={{border:"1px solid #fbc583"}}
                                     />
                                     <ErrorMessage
                                       name="stageAddress"
                                       component="div"
                                       className="validation"
                                     />
                                     </div>
                                     <div className="col-md-6 col-sm-6 col-xs-12">
                                     <label>
                                       Google Map Link{" "}
                                       <span className="validation"> *</span>{" "}
                                     </label>
                                     <Field
                                       rows="3"
                                       component="textarea"
                                       name="stageGoogleMapLink"
                                       id="stageGoogleMapLink"
                                       maxLength={255}
                                       title={values.stageGoogleMapLink}
                                       onChange={handleChange}
                                       placeholder="Stage Google Map Link"
                                       className={
                                         "form-control" +
                                         (errors.stageGoogleMapLink &&
                                         touched.stageGoogleMapLink
                                           ? " is-invalid"
                                           : "")
                                       }
                                       style={{border:"1px solid #fbc583"}}
                                     />
                                     <ErrorMessage
                                       name="stageGoogleMapLink"
                                       component="div"
                                       className="validation"
                                     />
                                     </div>
                                     </>
                                   )} 
                                </div>                               
                              </div>
                            </Form>
                          </div>
                          <div className="modal-footer">
                            <span style={{float:"right"}}>
                            <button
                              type="submit"
                              className="btn discount-table-heading"
                              onClick={handleSubmit}
                              disabled={this.state.isButtonDisabled === true ? true : false}
                            >
                              Save
                            </button>
                            <button
                              type="reset"
                              className="btn discount-table-heading"
                              onClick={()=>{handleReset();this.setState({isButtonDisabled:false})}}
                            >
                              Reset
                            </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
            />         

            {/* <!-- Update Status Modal Starts  --> */}
            <Formik
              enableReinitialize={true}
              initialValues={{
                // applicationStatus:this.state.searchType==="Job"?this.state.applicationStatus:this.state.searchType==="Course"?this.state.applicationStatusCourse:"",
                applicationStatus:this.state.searchType==="Job"?this.state.applicationStatus:this.state.searchType==="Course"?this.state.applicationStatusCourse==="In Process"?"":this.state.applicationStatusCourse:"",
                candidateId:this.state.searchType==="Job"?this.state.candidateId:this.state.searchType==="Course"?this.state.candidateIdCourse:"",
                partyId:this.state.searchType==="Job"?this.state.partyId:this.state.searchType==="Course"?this.state.partyIdCourse:"",
                comment: "",
                applicationId:this.state.searchType==="Job"?this.state.applicationId:this.state.searchType==="Course"?this.state.applicationIdCourse:"",
                jobId:this.state.searchType==="Job"?this.state.modalJobId:this.state.searchType==="Course"?this.state.modalCourseId:"",                
              }}
              validationSchema={Yup.object().shape({
                applicationStatus: Yup.string().required("You must specify a Application Status"),
                comment: Yup.string().required("You must specify Comment")
                .matches(/^[a-zA-Z0-9.]+[a-zA-Z0-9\s.]*$/,"First Space is Not Allowed , Only AlphaNumeric, Dot(.), Spaces are allowed."),
              })}
              onSubmit={(values)=>{
                console.log('status fields values',values);
                let candidate = values.candidateId.split("|");
                let candidateName = candidate[1].trim();
                this.setState({ loading : true,isStatusBtnDisabled:true})
                //! Status Update Payload
                let data;
                if(this.state.searchType==="Job"){
                data = [{
                  applicationId: values.applicationId,
                  applicationStatus: values.applicationStatus,
                  partyId: values.partyId,
                  jobId: values.jobId,
                  comment: values.comment
                }];     
              }
               if(this.state.searchType==="Course"){
                   data = [{
                    applicationId: values.applicationId,
                    applicationStatus: values.applicationStatus,
                    partyId: values.partyId,
                    jobId: null,
                    productId:values.jobId,
                    comment: values.comment,
                    emailID:this.state.candidateEmailId ? this.state.candidateEmailId : "",
                    candidateName:candidateName
                  }];   
                }           
                StudentAssessmentService.updateStatus(data, res => {
                  if (res.status === "success") {
                    success("Status Updated successfully. ", successNotification)
                    this.setState({ loading : false})
                    setTimeout(() => {
                      window.location.reload();
                    }, 2000);
                  } else {
                    warning(res.reasonText, {
                      ...warningNotification,
                      container: "top-center",
                    });
                    this.setState({ loading : false,isStatusBtnDisabled:false})
                  }
                })   
              }}
              render={({
                errors,
                touched,
                handleSubmit,
                setFieldValue,
                handleReset,
                values,
                handleChange,
              }) => (
                  <React.Fragment>
                    <div
                      className="modal fade"
                      id="statusModal"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="myModalLabel"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                              onClick={handleReset}
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 className="modal-title" id="myModalLabel">
                              Update Status
                            </h4>
                          </div>
                          <div className="modal-body">
                            <Form className="form-group">
                              <div className="form-group">
                                <div className="row">
                                  <div className="col-md-6 col-sm-6 col-xs-12">
                                      <label>
                                        Candidate{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="candidateId"
                                        id="candidateId"
                                        onChange={() => {
                                          if (!this.state.isEdit) handleChange();
                                        }}
                                        value={values.candidateId}
                                        placeholder="Candidate "
                                        disabled
                                        className="form-control" 
                                        style={{border:"1px solid #fbc583"}}
                                      />
                                  </div>
                                  <div className="col-md-6 col-sm-6 col-xs-12">
                                  <label>
                                        Status{" "}
                                        <span className="validation"> *</span>{" "}
                                      </label>
                                      <Field
                                        as="select"
                                        name="applicationStatus"
                                        id="applicationStatus"
                                        value={values.applicationStatus}
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.applicationStatus && touched.applicationStatus
                                            ? " is-invalid"
                                            : "")
                                        }
                                        style={{border:"1px solid #fbc583"}}
                                      >
                                      <>
                                        <option value="">-- Select --</option>
                                        <option value="Accepted">Accepted</option>
                                      {this.state.searchType==="Job"&&<option value="In Process">In Process</option>}
                                        <option value="Rejected">Rejected</option>
                                        {this.state.searchType==="Job"&&<option value="Shortlisted">Shortlisted</option>}
                                        </>
                                      </Field>
                                      <ErrorMessage
                                        name="applicationStatus"
                                        component="div"
                                        className="validation"
                                      />
                                      </div>
                                </div>
                                <div className="row">
                                   <div className="col-md-12 col-sm-12 col-xs-12">
                                   <label>
                                      Comment{" "}<span className="validation"> *</span>{" "}
                                    </label>
                                    <Field
                                      rows="4"
                                      component="textarea"
                                      maxLength={255}
                                      name="comment"
                                      id="comment"
                                      onChange={handleChange}
                                      title={values.comment}
                                      autoComplete="comment"
                                      className={
                                        "form-control" +
                                        (errors.comment &&
                                        touched.comment
                                          ? " is-invalid"
                                          : "")
                                      }
                                      style={{border:"1px solid #fbc583"}}
                                    />
                                    <ErrorMessage
                                      name="comment"
                                      className="validation"
                                      component="div"
                                    />
                                   </div>     
                                </div>
                              </div>
                            </Form>
                          </div>
                          <div className="modal-footer">
                            <span style={{float:"right"}}>
                            <button
                                type="submit"
                                className="btn discount-table-heading"
                                onClick={handleSubmit}
                                disabled={this.state.isStatusBtnDisabled === true ? true : false}
                            >
                              Save
                            </button>
                            <button
                              type="reset"
                              className="btn discount-table-heading"
                              onClick={()=>{handleReset();this.setState({isStatusBtnDisabled:false})}}
                            >
                              Reset
                            </button>
                           
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
            />        
            {/* <!-- Update Status Modal Ends  --> */}    

            {/* <!-- History Details Modal Starts  --> */}
            <div
              className="modal fade"
              id="historyModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
            >
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title" id="myModalLabel">
                      History Details
                    </h4>
                  </div>
                  <div className="modal-body">
                    <div className="table-responsive" style={{border:"none"}}>
                      <ReactTable
                        minRows={3}
                        data={this.state.searchType==="Job"?this.state.jobHistory:this.state.searchType==="Course"?this.state.courseHistory:[]}
                        filterable
                        ref={(refReactTable) => { this.refReactTable = refReactTable; }}
                        defaultFilterMethod={this.filterCaseInsensitive}
                        columns={[
                          {
                            columns: [
                              {
                                Header: "Candidate",
                                width:200,
                                id: "candidateID",
                                accessor: d => (d.candidateID || '---').toString(),
                                Cell: (props) => {
                                  return (
                                  <span title={props.original.candidateID ? props.original.candidateID : "---"}>
                                    {props.original.candidateID ? props.original.candidateID : "---"}</span>
                                  );
                                },
                                filterable: false,
                              },
                              {
                                Header: "Stage",
                                width:145,
                                id: "stageName",
                                accessor: d => (d.stageName || '---').toString(),
                                filterable: false,
                              },
                              {
                                Header: "Stage Date",
                                width:155,
                                id: "stageDate",
                                accessor: d => (d.stageDate || '---').toString(),
                                filterable: false,
                              },
                              {
                                Header: "Comments",
                                id: "comment",
                                accessor: d => (d.comment || '---').toString(),
                                filterable: false,
                                Cell: (props) => {
                                  return (
                                  <span title={props.original.comment ? props.original.comment : "---"}>
                                    {props.original.comment ? props.original.comment : "---"}</span>
                                  );
                                },
                                
                              },
                            ]
                          }
                        ]}
                        defaultPageSize={20}
                        style={{
                          width: "100%",
                          maxHeight: "500px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- History Details Modal Ends  --> */}

            <Finxfooter />
          </React.Fragment>
        )}
      />
    );
  }
}

export default AdminCadidate;

